import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderCheckboxTableComponent } from './checkbox-table.component';
import { FormsModule } from '@angular/forms';
import { RappiderTextModule } from '../text/text.module';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

@NgModule({
  declarations: [
    RappiderCheckboxTableComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RappiderTextModule,
    NzTableModule,
    NzCheckboxModule
  ],
  exports: [
    RappiderCheckboxTableComponent
  ]
})
export class RappiderCheckboxTableModule { }
